/*
 * Copyright (c) 2020.
 * Simon
 */

import React, {Component} from 'react';
import {Input} from "reactstrap";
import {i18n} from "../../language/i18n";
import isURL from "../../utils/isURL";
import checkImg from "../../utils/checkImg";

class HearImage extends Component {

    constructor(props) {
        super(props);

        this.state = {
            url: "",
            urlValid: false,
            urlInvalid: false,
        };
    }

    componentDidMount() {
        this.updateUrlFromProps(this.props);
    }

    componentWillReceiveProps(nextProps, nextContext) {
        let url = nextProps.replyData.url;
        this.setState({
            url: url,
            urlValid: false,
            urlInvalid: false,
        });
    }

    updateUrlFromProps(props) {
        let replyData = props.replyData;

        let url = replyData === undefined ? "" : replyData['url'];
        url = url === undefined ? "" : url;
        url = url === null ? "" : url; //TODO: Condition is always false since types 'string' and 'null' have no overlap
        this.setState({url: url});
    }


    handleChange = (event) => {
        const {hearReplies, replyIndex} = this.props;
        let checkURL = checkImg(event.target.value);

        if (isURL(event.target.value) && checkURL) {
            this.setState({urlValid: true, urlInvalid: false});
            hearReplies.updateReply(replyIndex, "url", event.target.value);
        } else {
            this.setState({urlValid: false, urlInvalid: true});
        }

        this.setState({url: event.target.value});

    };

    render() {
        return (
            <div className="hear-element hear-image">
                <Input
                    placeholder={i18n.t("URL") + " https://..."}
                    id={'reply_image_' + this.props.replyIndex}
                    onChange={this.handleChange}
                    value={this.state.url}
                    invalid={this.state.urlInvalid}
                    valid={this.state.urlValid}
                />
                <small className="form-text text-muted">
                    <b className="text-danger">{i18n.t("Required.")}</b>&nbsp;
                    {i18n.t("The URL of image.")}
                </small>
            </div>
        );
    }
}

export default HearImage;

